import classNames from 'classnames';
import { ReactNode } from 'react';
import { MdInfo, MdWarning } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { Tooltip, Whisper } from 'rsuite';
import { ButtonSecondary } from '../../../../../components/ButtonSecondary';
import { BASIC_CONFIG_ROUTE, OPPOSITE_PRICE_MODE, PRICE_MODE_CONFIG, PriceMode } from '../../priceMode';
import styles from './PsychologicalPriceHeader.module.scss';

export type PsychologicalPriceHeaderProps = {
  mode: PriceMode;
  lastUpdate?: string | null;
  // O modo avançado não tem data confiável de atualização das faixas, então não exibe o campo.
  showLastUpdate?: boolean;
  actions?: ReactNode;
  className?: string;
};

// Larguras do Figma: a descrição do Simplificado cabe em 2 linhas, a do Avançado em 3.
const TOOLTIP_WIDTH_CLASS: Record<PriceMode, string> = {
  SIMPLIFIED: styles.tooltipWide,
  ADVANCED: styles.tooltipNarrow,
};

function formatLastUpdate(lastUpdate?: string | null): string {
  if (!lastUpdate) return '--';
  return new Date(lastUpdate).toLocaleDateString('pt-BR');
}

export const PsychologicalPriceHeader = ({ mode, lastUpdate, showLastUpdate = true, actions, className }: PsychologicalPriceHeaderProps) => {
  const history = useHistory();

  const targetModeKey = OPPOSITE_PRICE_MODE[mode];
  const currentMode = PRICE_MODE_CONFIG[mode];
  const targetMode = PRICE_MODE_CONFIG[targetModeKey];

  return (
    <header className={classNames(styles.container, className)}>
      <div className={styles.info}>
        <div className={styles.titleRow}>
          <h1 className={styles.title}>Preço psicológico</h1>
          <span className={styles.warning}>
            <MdWarning className={styles.warningIcon} />
            As alterações serão aplicadas na próxima integração de dados
          </span>
        </div>
        <div className={styles.details}>
          <Whisper
            placement="right"
            trigger="hover"
            speaker={<Tooltip className={classNames(styles.tooltip, TOOLTIP_WIDTH_CLASS[mode])}>{currentMode.description}</Tooltip>}
          >
            <span className={styles.modeBadge} data-testid="price-mode-badge">
              <MdInfo className={styles.modeBadgeIcon} />
              {currentMode.label}
            </span>
          </Whisper>
          {showLastUpdate && <span className={styles.lastUpdate}>Última atualização: {formatLastUpdate(lastUpdate)}</span>}
        </div>
      </div>
      <div className={styles.actions}>
        {actions}
        <Whisper
          placement="left"
          trigger="hover"
          speaker={
            <Tooltip className={classNames(styles.tooltip, styles.tooltipAlignedRight, TOOLTIP_WIDTH_CLASS[targetModeKey])}>
              {targetMode.description}
            </Tooltip>
          }
        >
          <ButtonSecondary theme="blue" size="md" type="button" onClick={() => history.push(BASIC_CONFIG_ROUTE)}>
            Mudar para {targetMode.label.toLowerCase()}
          </ButtonSecondary>
        </Whisper>
      </div>
    </header>
  );
};
